import React from 'react'

export default function Corporate() {
    return (
        
        <main>
<section></section>
        </main>
    )
}
